import React, { useEffect, useState } from 'react';
import { Navbar } from '../components/Navbar';
import { StickyFooter } from '../components/StickyFooter';
import { FadeIn } from '../components/FadeIn';
import { useModals } from '../contexts/ModalContext';
import { CheckCircleIcon, HeartIcon, ShieldCheckIcon, ClockIcon, PlayIcon, StarIcon, MapPinIcon, VideoIcon } from 'lucide-react';
const MOCK_NANNIES = [{
  id: 1,
  name: 'Sarah M.',
  location: 'Raleigh, NC',
  rate: '$22/hr',
  rating: 4.9,
  reviews: 34,
  bio: 'Former preschool teacher with 6 years of infant care experience. CPR & First-Aid certified.',
  image: 'https://images.unsplash.com/photo-1573496359142-b8d87734a5a2?w=400&auto=format&fit=crop',
  badges: ['Infant Care', 'Full-Time']
}, {
  id: 2,
  name: 'Jessica T.',
  location: 'Durham, NC',
  rate: '$20/hr',
  rating: 5.0,
  reviews: 18,
  bio: 'Nursing student available for part-time and emergency backup care. Loves outdoor activities.',
  image: 'https://images.unsplash.com/photo-1580489944761-15a19d654956?w=400&auto=format&fit=crop',
  badges: ['Part-Time', 'Pet Friendly']
}, {
  id: 3,
  name: 'Emily R.',
  location: 'Chapel Hill, NC',
  rate: '$25/hr',
  rating: 4.8,
  reviews: 42,
  bio: 'Bilingual (English/Spanish) nanny specializing in toddler development and meal prep.',
  image: 'https://images.unsplash.com/photo-1598550874175-4d0ef43eeedb?w=400&auto=format&fit=crop',
  badges: ['Toddlers', 'Bilingual']
}];
export function Childcare() {
  const {
    openModal
  } = useModals();
  const [activeFilter, setActiveFilter] = useState('All');
  useEffect(() => {
    document.title = "Vetted In-Home Nannies & Childcare | Care Nomad";
  }, []);
  return <div className="min-h-screen w-full bg-white flex flex-col" data-id="element-939" data-mp="1laqaq1ia4q4e">
      <Navbar data-id="element-940" data-mp="1gb5brr340hro" />
      
      <main className="flex-1" data-id="element-941" data-mp="1gbww25r9at2n">
        {/* High-Intent PPC Hero Section */}
        <section className="w-full relative py-16 lg:py-24 flex items-center justify-center min-h-[60vh]" data-id="element-942" data-mp="1c9s4dckdc6in">
          <div className="absolute inset-0 z-0" data-id="element-943" data-mp="179npfqz3zjuj">
            <img src="https://images.unsplash.com/photo-1587691592099-24045742c181?w=1600&auto=format&fit=crop" alt="Childcare Background" className="w-full h-full object-cover" data-id="element-944" data-mp="17ca56dw5l5nu" />
            <div className="absolute inset-0 bg-gradient-to-r from-[#1a2332]/95 to-[#1a2332]/70" data-id="element-945" data-mp="11pq2xtddsahw"></div>
          </div>
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10 w-full" data-id="element-946" data-mp="nqi10spu2oa0">
            <div className="max-w-3xl" data-id="element-947" data-mp="snql4yujl2dw">
              <FadeIn direction="up" data-id="element-948" data-mp="1gdb61na9a9pt">
                <h1 className="text-4xl sm:text-5xl lg:text-6xl font-extrabold text-white tracking-tight mb-6 leading-tight" data-id="element-949" data-mp="1gedvrrvue645">
                  Trusted, Vetted In-Home Nannies—Backed by <span className="text-[#007a87]" data-id="element-950" data-mp="16nrkuaz2m3rs">AI Video Check-Ins</span>
                </h1>
                <p className="text-lg sm:text-xl text-white/90 mb-8 leading-relaxed font-medium" data-id="element-951" data-mp="1bm2sqg5t247d">
                  Connect with CPR-certified, background-checked child, pet, and household nannies across NC, VA, MD, and DC. Monitor daily routines with live photo and micro-video activity feeds.
                </p>
                <div className="flex flex-col sm:flex-row gap-4 mb-10" data-id="element-952" data-mp="3os96n7xb7c37">
                  <button onClick={() => openModal('talent')} className="bg-[#5a55ea] hover:bg-[#4b47c4] text-white font-bold py-4 px-8 rounded-xl transition-colors text-lg shadow-lg flex items-center justify-center gap-2" data-id="element-953" data-mp="3jtzfd8epgvmv">
                    Find a Vetted Nanny in 2 Minutes
                  </button>
                  <a href="#check-ins" className="bg-white/10 hover:bg-white/20 backdrop-blur-md text-white font-bold py-4 px-8 rounded-xl transition-colors text-lg border border-white/30 flex items-center justify-center gap-2" data-id="element-954" data-mp="35twvxhqr1u5i">
                    <PlayIcon className="w-5 h-5" data-id="element-955" data-mp="3evxrma6c4852" />
                    See How Video Check-Ins Work
                  </a>
                </div>
                
                <div className="flex flex-wrap gap-4 text-sm font-medium text-white/80" data-id="element-956" data-mp="u4nk6d2vndh5">
                  <span className="flex items-center gap-1.5" data-id="element-957" data-mp="u6guq3gm2huf"><ShieldCheckIcon className="w-4 h-4 text-green-400" data-id="element-958" data-mp="p4j2wku5aepv" /> 100% Background Checked</span>
                  <span className="flex items-center gap-1.5" data-id="element-959" data-mp="1kgsmc62gvqcb"><HeartIcon className="w-4 h-4 text-green-400" data-id="element-960" data-mp="1khtwm8bns8sz" /> CPR & First-Aid Certified</span>
                  <span className="flex items-center gap-1.5" data-id="element-961" data-mp="1pgww7d8vdmtk"><CheckCircleIcon className="w-4 h-4 text-green-400" data-id="element-962" data-mp="1udnjoln07kp0" /> Zero Search Fees Until You Hire</span>
                  <span className="flex items-center gap-1.5" data-id="element-963" data-mp="1ze1gf7j5n87q"><StarIcon className="w-4 h-4 text-yellow-400 fill-yellow-400" data-id="element-964" data-mp="1zax941ae7wcu" /> 4.9/5 Star Family Rating</span>
                </div>
              </FadeIn>
            </div>
          </div>
        </section>

        {/* Interactive Profile Grid */}
        <section className="py-20 bg-gray-50" data-id="element-965" data-mp="2d451hv6asvvl">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-966" data-mp="2d6ho4ln03uez">
            <div className="flex flex-col md:flex-row justify-between items-end mb-10 gap-6" data-id="element-967" data-mp="2i26j0bo2sn4y">
              <div data-id="element-968" data-mp="2n3vt9p3h4wrz">
                <h2 className="text-3xl font-bold text-[#1a2332] mb-3" data-id="element-969" data-mp="2n4fbl6x1dn6j">Top-Rated Nannies Near You</h2>
                <p className="text-[#5a6a7a]" data-id="element-970" data-mp="2r4fq0rk4xydl">Browse pre-screened professionals ready to interview today.</p>
              </div>
              <div className="flex gap-2 overflow-x-auto pb-2 w-full md:w-auto hide-scrollbar" data-id="element-971" data-mp="bf8v4ox6juzg">
                {['All', 'Full-Time', 'Part-Time', 'Infant Care', 'Emergency'].map(filter => <button key={filter} onClick={() => setActiveFilter(filter)} className={`px-4 py-2 rounded-full text-sm font-bold whitespace-nowrap transition-colors ${activeFilter === filter ? 'bg-[#1a2332] text-white' : 'bg-white text-[#5a6a7a] border border-gray-200 hover:border-[#1a2332]'}`} data-id="element-972" data-mp="1h1g4bmgbn03">
                    {filter}
                  </button>)}
              </div>
            </div>

            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8" data-id="element-973" data-mp="ke2xyx13thlg">
              {MOCK_NANNIES.map((nanny, idx) => <FadeIn key={nanny.id} direction="up" delay={idx * 0.1} data-id="element-974" data-mp="1d4b8c2peexph" data-mpi={idx}>
                  <div className="bg-white rounded-3xl overflow-hidden shadow-sm border border-gray-100 hover:shadow-xl transition-all duration-300 group" data-id="element-975" data-mp="37cf0qpnkcqs9">
                    <div className="relative h-64 overflow-hidden" data-id="element-976" data-mp="3bdihrfhcksv2">
                      <img src={nanny.image} alt={nanny.name} className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-700" data-id="element-977" data-mp="2xnf1r6929ve2" />
                      <div className="absolute top-4 right-4 bg-white/90 backdrop-blur-sm px-3 py-1 rounded-full text-sm font-bold text-[#1a2332] shadow-sm" data-id="element-978" data-mp="32jdj49vz2d4z">
                        {nanny.rate}
                      </div>
                      <div className="absolute bottom-4 left-4 flex gap-2" data-id="element-979" data-mp="2eo134b0dzwh8">
                        {nanny.badges.map(badge => <span key={badge} className="bg-[#1a2332]/80 backdrop-blur-md text-white text-xs font-bold px-2.5 py-1 rounded-md" data-id="element-980" data-mp="2jnnfyjcazapi">
                            {badge}
                          </span>)}
                      </div>
                    </div>
                    <div className="p-6" data-id="element-981" data-mp="s0hc7w87zz6v">
                      <div className="flex justify-between items-start mb-3" data-id="element-982" data-mp="rxbnwj7f11c7">
                        <div data-id="element-983" data-mp="n1wcdxwvrhiy">
                          <h3 className="text-xl font-bold text-[#1a2332] flex items-center gap-2" data-id="element-984" data-mp="myi82k4noy8v">
                            {nanny.name}
                            <ShieldCheckIcon className="w-5 h-5 text-blue-500" data-id="element-985" data-mp="w0rjrdbnuxnu" />
                          </h3>
                          <p className="text-[#5a6a7a] text-sm flex items-center gap-1 mt-1" data-id="element-986" data-mp="1aomawpa0styt">
                            <MapPinIcon className="w-4 h-4" data-id="element-987" data-mp="15prkb15ta145" /> {nanny.location}
                          </p>
                        </div>
                        <div className="flex items-center gap-1 bg-yellow-50 text-yellow-700 px-2 py-1 rounded-lg text-sm font-bold" data-id="element-988" data-mp="1johp72yvh532">
                          <StarIcon className="w-4 h-4 fill-yellow-500 text-yellow-500" data-id="element-989" data-mp="3lhfckj9vr5gm" />
                          {nanny.rating}
                        </div>
                      </div>
                      <p className="text-[#5a6a7a] text-sm leading-relaxed mb-6 line-clamp-2" data-id="element-990" data-mp="9vxlldo972qv">
                        {nanny.bio}
                      </p>
                      <button onClick={() => openModal('talent')} className="w-full bg-gray-50 hover:bg-[#5a55ea] text-[#1a2332] hover:text-white border border-gray-200 hover:border-[#5a55ea] font-bold py-3 rounded-xl transition-colors flex items-center justify-center gap-2" data-id="element-991" data-mp="etfu52yczfyc">
                        <VideoIcon className="w-5 h-5" data-id="element-992" data-mp="3n3hd80pcj60e" />
                        Book 1-Click Video Interview
                      </button>
                    </div>
                  </div>
                </FadeIn>)}
            </div>
          </div>
        </section>

        {/* Feature Deep Dive */}
        <section id="check-ins" className="py-20 bg-white" data-id="element-993" data-mp="4xmbr2xyks8n">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-994" data-mp="1bder7l3b3hp5">
            <div className="text-center mb-16" data-id="element-995" data-mp="1bf9db2qbdfut">
              <h2 className="text-3xl lg:text-4xl font-bold text-[#1a2332] mb-4" data-id="element-996" data-mp="1gaygdg1jlevv">Why Parents Choose CareNomad</h2>
              <p className="text-[#5a6a7a] text-lg max-w-2xl mx-auto" data-id="element-997" data-mp="1qelmczkrnqdb">The traditional listing sites leave you in the dark. We built a platform for modern accountability.</p>
            </div>

            <div className="max-w-4xl mx-auto bg-white rounded-3xl shadow-xl border border-gray-100 overflow-hidden" data-id="element-998" data-mp="1gp22prp8bshe">
              <div className="grid grid-cols-3 bg-gray-50 border-b border-gray-200 p-6 font-bold text-[#1a2332]" data-id="element-999" data-mp="1co09pslwocnv">
                <div className="col-span-1" data-id="element-1000" data-mp="17nc8yf7vkhgg">Feature</div>
                <div className="text-center text-[#007a87]" data-id="element-1001" data-mp="12pas80xx8u85">CareNomad</div>
                <div className="text-center text-gray-400" data-id="element-1002" data-mp="xqzg1jk5m7mr">Traditional Sites</div>
              </div>
              {[{
              name: 'AI Video Check-Ins',
              us: true,
              them: false
            }, {
              name: 'Automated Geofencing (EVV)',
              us: true,
              them: false
            }, {
              name: '1-Click Video Interviews',
              us: true,
              them: false
            }, {
              name: 'Free Messaging & Search',
              us: true,
              them: false
            }, {
              name: 'Background Checks Included',
              us: true,
              them: 'Extra Fee'
            }].map((row, i) => <div key={i} className="grid grid-cols-3 p-6 border-b border-gray-100 last:border-0 items-center" data-id="element-1003" data-mp="373jolk7s58tu" data-mpi={i}>
                  <div className="col-span-1 font-medium text-[#1a2332]" data-id="element-1004" data-mp="3l32ue6d4c82z">{row.name}</div>
                  <div className="text-center flex justify-center" data-id="element-1005" data-mp="3g5asqkmo97ll">
                    <CheckCircleIcon className="w-6 h-6 text-green-500" data-id="element-1006" data-mp="2sef8c8kjpeod" />
                  </div>
                  <div className="text-center flex justify-center text-[#5a6a7a] font-medium" data-id="element-1007" data-mp="2ngvh882r17f0">
                    {row.them === false ? <div className="w-4 h-0.5 bg-gray-300 rounded-full" data-id="element-1008" data-mp="325rwap383kp4"></div> : row.them}
                  </div>
                </div>)}
            </div>
          </div>
        </section>

        {/* Frictionless Lead Capture */}
        <section className="py-20 bg-[#007a87]" data-id="element-1009" data-mp="29mclugl83467">
          <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center" data-id="element-1010" data-mp="24okqtdpa71xs">
            <FadeIn direction="up" data-id="element-1011" data-mp="k71zcku9iph3">
              <h2 className="text-3xl lg:text-4xl font-bold text-white mb-6" data-id="element-1012" data-mp="k60mqbxllux9">Ready to find your perfect match?</h2>
              <p className="text-white/90 text-lg mb-10" data-id="element-1013" data-mp="p0d4mhjfey6w">Tell us what you need, and we'll send you the top 3 vetted profiles in your area.</p>
              <button onClick={() => openModal('talent')} className="bg-white text-[#007a87] hover:bg-gray-50 font-bold py-4 px-10 rounded-xl transition-colors text-lg shadow-xl" data-id="element-1014" data-mp="f7z2hnofrpk7">
                Start Free Search
              </button>
            </FadeIn>
          </div>
        </section>

        {/* FAQ */}
        <section className="py-20 bg-gray-50" data-id="element-1015" data-mp="ty699652zk52">
          <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-1016" data-mp="tzhd15yj0rw6">
            <h2 className="text-3xl font-bold text-[#1a2332] mb-10 text-center" data-id="element-1017" data-mp="yv51tk93jj15">Frequently Asked Questions</h2>
            <div className="space-y-4" data-id="element-1018" data-mp="3em14c8691jv9">
              {[{
              q: 'How does the background check process work?',
              a: 'Every caregiver undergoes a comprehensive multi-state criminal background check, sex offender registry search, and identity verification before their profile goes live.'
            }, {
              q: 'Are there any upfront fees?',
              a: 'No. You can search, message, and interview candidates for free. You only pay a transparent placement fee when you officially hire a caregiver through our platform.'
            }, {
              q: 'How do CareNomad Check-Ins™ work?',
              a: 'Our proprietary app uses geofencing to verify when a caregiver arrives. Throughout the day, it prompts them to upload quick photos or 5-second videos of meals and activities directly to your family dashboard.'
            }, {
              q: 'Do you help with nanny taxes (W-2 vs 1099)?',
              a: 'Yes! Our platform provides automated timesheets and integrates with leading household payroll providers to make tax compliance seamless.'
            }].map((faq, i) => <div key={i} className="bg-white p-6 rounded-2xl shadow-sm border border-gray-100" data-id="element-1019" data-mp="2muien5afq4d7" data-mpi={i}>
                  <h4 className="font-bold text-[#1a2332] text-lg mb-2" data-id="element-1020" data-mp="8mzkq32opmwe">{faq.q}</h4>
                  <p className="text-[#5a6a7a] leading-relaxed" data-id="element-1021" data-mp="dlkk60a442js">{faq.a}</p>
                </div>)}
            </div>
          </div>
        </section>
      </main>

      <StickyFooter data-id="element-1022" data-mp="iedqutp55kyi" />
    </div>;
}